import { environment } from 'src/environments/environment';
const baseUrl = `${environment.apiBaseUrl}api/`;
const baseUrl2 = `${environment.apiBaseUrl}api/`;
const officebaseUrl = `${environment.apiBaseUrl}`;
const vmsBaseUrl = `${environment.vmsBaseUrl}api/`;
const vmsBridgePlusBaseUrl = `${environment.vmsBridgePlusBaseUrl}api/`;
const eventBaseUrl = `${environment.eventBaseUrl}api/`;
const pmsBaseUrl = `${environment.apiBaseUrlPms}api/`;
const userMgmtBaseUrl = `${environment.apiBaseUrlUserMgmt}api/`;
const baseUrl4 = `${environment.facilityBaseUrl}api/`;

const apiversion = "v1/";

export const APIs = {
  // getAuthToken: `${baseUrl}Home/oAuth/token`,
  // getMeetingRoomList:`${baseUrl}Home/resources`,
  // getCredits:`${baseUrl}credit-accounts/stats`
  postMeeting: `${baseUrl}Meeting/BookMeeting`,
  getDatabaseCredits: `${baseUrl}Credit/GetCredit`,
  getAllCredits: `${baseUrl}Credit/GetCredit`,
  getMeetingDetail: `${baseUrl}Meeting/GetMeetingDetail`,
  cancelMeeting: `${baseUrl}Meeting/CancelMeeting`,
  saveMeetingInvitees: `${baseUrl}MeetingInvitees/SaveMeetingInvitees`,
  saveMeetingInvitees2: `${baseUrl}MeetingInvitees/SaveMeetingInvitees2`,
  saveExternalMeetingInvitees: `${baseUrl}MeetingInvitees/SaveExternalMeetingInvitee`,
  removeMemberFromMeeting: `${baseUrl}MeetingInvitees/RemoveMeetingInvitee`,
  getMeetingRoomDetail: `${baseUrl}MeetingRoom/GetMeetingRoomDetail`,
  getMeetingInviteesList: `${baseUrl}MeetingInvitees/GetMeetingInviteesList`,
  getmeetingInviteesWithExternals: `${baseUrl}MeetingInvitees/meetingInvitees`,
  getApiAuthToken: `${baseUrl}token`,
  getAuthToken: `${baseUrl}OfficeRnd/oAuth/token`,
  getOfficeMembers: `${baseUrl}OfficeRnd/members`,
  getOfficeAccessPoints: `${baseUrl}OfficeRnd/resources`,
  getMeetingRoomOfficerndList: `${baseUrl}Home/resources`,
  getMeetingRoomList: `${baseUrl}Meeting/GetMeetingList`,
  getMeetingRoomListDetails: `${baseUrl}MeetingRoom/GetMeetingRoomList`,
  getTimelineData: `${baseUrl}Meeting/GetTimeLineData`,
  getCredits: `${baseUrl}credit-accounts/stats`,
  getDepartmentList: `${baseUrl}Employees/departmentList`,
  getRfidList: `${baseUrl}Employees/GetUnassignedCards`, //tenantwiseunassignedcardlist
  getAccessPoint: `${baseUrl}Employees/getAccessPoints`,
  addemployee: `${baseUrl}Employees/addEmployee`,
  updateemployeeRfid: `${baseUrl}Employee/UpdateMemberAccessCard`,
  getEmployeeList: `${baseUrl}Employees/GetEmployeeList`,
  updateUserAccessPoint: `${baseUrl}Employees/updateAccessPoint`,
  getUserInfo: `${baseUrl}Employees/getUserInfo`,
  getUserDepartmentInfo: `${baseUrl}Employees/getUserDepartmentInfo`,
  resendEmail: `${baseUrl}Employees/resendEmail`,
  getUserAccessPoints: `${baseUrl}Employees/getUserAccessPoints`,
  revokeAccess: `${baseUrl}Company/RemoveOrgEmployee`,
  addorupdateuserRole: `${baseUrl}Company/addorupdateUserRole`,
  addorupdateTenant: `${baseUrl}Company/addorupdateTenant`,
  addorupdateOrgEmployee: `${baseUrl}Company/addorupdateOrgEmployee`,
  gettenantbyUserId: `${baseUrl}Company/GetTenantbyUserId`,
  gettennatEmployeeList: `${baseUrl}Employees/GetTenantEmployeeList`,
  getEmailid: `${baseUrl}Employee/GetEmployeeList`,
  getUserDetail: `${baseUrl}Users`,
  getAdminDetails: `${baseUrl}Token/CheckAdmin`,
  getReportMeetingRooms: `${baseUrl}report/meetingrooms`,
  getAccessPoints: `${baseUrl}report/accesspoints`,
  getCheckins: `${baseUrl}report/checkins`,
  getCreditReports: `${baseUrl}report/creditreports`,
  getDepartments: `${baseUrl}report/departments`,
  getEmployees: `${baseUrl}report/employees`,
  getMeetings: `${baseUrl}report/meetings`,
  // getContactsData: `${baseUrl}Contact`,
  getContactsData: `${baseUrl}Contact/GetContactPortal`,

  getCoAdmins: `${baseUrl}Employees/getcoadmin`,
  getAdminData: `${baseUrl}Employees/getadmin`,
  removeUser: `${baseUrl}users/RemoveUser`,
  getTenantCredit: `${baseUrl}Credit/GetCredit`,
  getTenantFutureCredit: `${baseUrl}Credit/GetFutureCredit`,
  updateUserCreditAccess: `${baseUrl}Users/ChangeCreditAccess`,
  changeCreditAccess: `${baseUrl}Users/ChangeCreditAccess`,
  disbursePoint: `${baseUrl}Credit/DisburseCreditPoints`,
  getTenantUser: `${baseUrl}Credit/GetMonthlyCreditSpentByTenantId`,
  getOverviewTenant: `${baseUrl}OverView/GetOverviewTenant`,
  getTenantOtherDetails: `${baseUrl}Company/GetTenantOtherDetails`,
  forgotPasswordPortal: `${baseUrl}Users/ForgetPasswordPortal`,
  user: `${baseUrl}Users`,
  removeCoAdmin: `${baseUrl}Employees/remove`,
  saveCoAdmin: `${baseUrl}Employees/SaveAdmin`,
  updateCoAdmin: `${baseUrl}Employees/UpdateAdmin`,
  getTenantSavedAccessPoints: `${baseUrl}Employees/getTenantSavedAccessPoints`,
  getadmindetails: `${baseUrl}Employees/getadmindetails`,
  getParkiteAdmin: `${baseUrl}pms/Employees/GetParkiteAdminDetails`,
  changeActivation: `${baseUrl}Employees/UpdateTenantMemberStatus`,
  getBulkEmployeesUploadTemplate: `${baseUrl}Employees/GetBulkEmployeesUploadTemplate`,
  getBulkEmployeesUploadTemplateOthers: `${baseUrl}Employees/GetBulkEmployeesUploadTemplate`,
  bulkEmployeesUpload: `${baseUrl}Employees/BulkUpload`,
  isTenantAdminExists: `${baseUrl}Token/IsTenantAdminExists`,
  // updatePassword: `${baseUrl}Users/UpdatePasswordPortal`,
  sendEmailsToMember: `${baseUrl}Employees/SendMembersOnboardingEmail`,
  getAllNotifications: `${baseUrl}PushNotification/GetTAPortalNotificationDetails`,
  clearNotification: `${baseUrl}PushNotification/ClearPortalNotification`,
  updateNotification: `${baseUrl}PushNotification/UpdateNotification`,
  updateMemberAccessPoint: `${baseUrl}Employees/UpdateUserAccessPoint`,
  RequestCreditPoints: `${baseUrl}Credit/SendRequestCreditPointsmail`,
  logoutToken: `${baseUrl}Token/Logout`,
  resetPassword: `${baseUrl}users/UpdatePasswordPortalNew`,
  updatePassword: `${baseUrl}users/ChangePasswordPortal`,
  ChangePasswordTAParkitePortal: `${baseUrl}Users/ChangePasswordTAParkitePortal`,
  revokeEmployeeRights: `${baseUrl2}pms/Employees/RevokeAccess`,
  saveEmployees: `${baseUrl2}pms/Employees/SaveEmployee`,
  getBuildingByParkId: `${baseUrl2}pms/Company/GetBuildingListByPark`,
  getBuildingByParkIdAndTenatID: `${baseUrl}pms/Park/GetParkBuildings`,
  getEmployeeDetailsByTenantId: `${baseUrl}pms/Employees/CurrentUserDetails`,
  employeeListByFilter: `${baseUrl2}pms/Employees/EmployeeDetailsWithFilter`,
  employeeVmsInvitationRights: `${vmsBaseUrl}VMS/VMS/VMSAccess`,
  saveEmployeeStatus: `${baseUrl2}pms/Employees/SaveEmployeeStatus`,
  markAsErt: `${baseUrl2}pms/Employees/MarkErt`,
  markAsCoadmin: `${baseUrl2}pms/Employees/Markcoadmin`,
  // getMyCompanyDetails: `${baseUrl2}pms/Employees/GetMyCompanyDetails`,

  getOverviewTA: `${baseUrl2}pms/OverView/GetOverViewDetails`,
  //Phase2 Apis - PMS
  getMyCompanyDetails: `${baseUrl2}pms/Employees/GetMyCompanyDetails`,
  getBulkParkEmployeesUploadTemplate: `${baseUrl}pms/BulkUpload/GetBulkEmployeesUploadTemplate`,
  bulkParkEmployeesUpload: `${baseUrl}pms/BulkUpload/BulkUpload`,
  saveBulkParkUsersDetails: `${baseUrl}pms/BulkUpload/SaveBulkParkUsersDetails`,
  deleteParkUserDetail: `${baseUrl}pms/BulkUpload/DeleteParkUserDetail`,
  deleteBaseUsersDetail: `${baseUrl}pms/BulkUpload/DeleteBaseUsersDetail`,
  sendEmailsToParkUsers: `${baseUrl}pms/BulkUpload/SendWelcomeMembersMessage`,
  verifyEmail: `${baseUrl}pms/Employees/VerifyEmail`,
  reBulkUpload: `${baseUrl}pms/BulkUpload/ReBulkUpload`,


  // phse 2 VMS
  getVmsHostDetail: `${vmsBaseUrl}VMS/VMSGuest/GetHostDetails`,
  getVmsVehicleType: `${vmsBaseUrl}VMS/VMSMasterData/GetVehicleType`,
  createVmsInvitation: `${vmsBaseUrl}VMS/VMS/CreateInvitation`,
  getVmsMeetingPurpose: `${vmsBaseUrl}VMS/VMSMasterData/GetMeetingPurpose`,
  getInvitationDetail: `${vmsBaseUrl}VMS/VMS/GetInvitationDetails`,
  resendInvitation: `${vmsBaseUrl}VMS/VMS/ResendInvitation`,
  cancelInvitation: `${vmsBaseUrl}VMS/VMS/CancelInvitation`,
  getVmsInvitationList: `${vmsBaseUrl}VMS/VMS/GetInvitationListForLandingPage`,
  getBulkInviteTemplate: `${vmsBaseUrl}VMS/VMSGuest/GetBulkInviteExcelTemplate`,
  getInvitationType: `${vmsBaseUrl}VMS/VMSMasterData/GetInvitationType`,
  deleteVmsGuest: `${vmsBaseUrl}VMS/VMSGuest/DeleteGuest`,
  getHostList: `${vmsBaseUrl}VMS/VMSGuest/GetHostList`,
  getBuildingList: `${vmsBaseUrl}VMS/VMS/GetVMSBuildingList`,
  getVMSBuildingListByTenant: `${vmsBaseUrl}VMS/VMS/GetVMSBuildingListByTenant`,
  getVmsInvitationRights: `${vmsBaseUrl}VMS/VMS/GetVMSAccessPendingRequestAndHistoryList`,
  getVmsRequestHistory: `${vmsBaseUrl}VMS/VMS/GetVMSAccessHistory`,
  cancelVmsAccess: `${vmsBaseUrl}VMS/VMS/CancelVMSAccessRequest`,
  sendRemainderVmsAccess: `${vmsBaseUrl}VMS/VMS/ApproveVMSAccessRemiderEmail`,
  //reports
  getFireWardenReportData: `${baseUrl}FireWarden/FireWarden/FireWardenReportTA`,
  getInviteCompanyList: `${vmsBaseUrl}VMS/VMSTab/GetCompanyListByPark`,
  getHistoryDetails: `${vmsBaseUrl}VMS/VMS/GetVMSInvitationHistory`,
  approvalRemainder: `${vmsBaseUrl}VMS/VMS/BulkInvitationApprovalReminder`,
  getVMSReportData: `${vmsBaseUrl}VMS/VMSReport/VMSTAReport`,
  getLocationPark: `${baseUrl}pms/Park/GetParkByTAUserId`,
  getLocParkByTenantId: `${baseUrl}pms/Park/GetParkByTenantIdForTA`,
  EmployeeListBasedonTenant: `${baseUrl}pms/Employees/EmployeeListBasedonTenant`,
  getVMSBPReportData: `${vmsBridgePlusBaseUrl}VMS/VMSReport/VMSBridgePlusTAReport`,
  //bridgeplus vms
  getBridgeplusHistoryDetails: `${vmsBridgePlusBaseUrl}VMS/VMSBridgePlus/GetVMSBridgePlusInvitationHistory`,
  getBridgePlusBuildingList: `${vmsBridgePlusBaseUrl}VMS/VMSBridgePlus/GetVMSBridgePlusBuildingList`,
  getVmsBridgePlusHostList: `${vmsBridgePlusBaseUrl}VMS/VMSBridgePlus/GetVMSBridgePlusUserList`,
  getVmsBridgePlusHostDetails: `${vmsBridgePlusBaseUrl}VMS/VMSBridgePlus/GetBridgePlusHostDetails`,
  createVMSforExternalEmp: `${vmsBridgePlusBaseUrl}VMS/VMSBridgePlus/SaveExternalEmployeesForVMS`,
  getBridgePlusVmsInvitationList: `${vmsBridgePlusBaseUrl}VMS/VMSBridgePlus/GetBridgePlusInvitationListForLandingPage`,


  // events

  getEventType: `${eventBaseUrl}Events/Events/GetEventsType`,
  GetEventsCategory: `${eventBaseUrl}Events/Events/GetEventsCategoryType`,
  getEvents: `${eventBaseUrl}Events/Events/EventList`,
  GetEventListByParkId: `${eventBaseUrl}Events/Events/GetEventListByParkId`,
  getEventsTaBP: `${eventBaseUrl}Events/Events/EventListforBridgePlusTa`,
  getEventDetailById: `${eventBaseUrl}Events/Events/EventDetailsById`,
  GetEventsImageType: `${eventBaseUrl}Events/Events/GetEventsImageType`,
  GetEventsAttendeeType: `${eventBaseUrl}Events/Events/GetEventsAttendeeType`,
  SaveEvents: `${eventBaseUrl}Events/Events/SaveEvents`,
  GetParticipantListDetails: `${eventBaseUrl}Events/Participation/GetParticipantListDetails`,
  GetGuestList: `${eventBaseUrl}Events/Events/GuestList`,
  GuestApproveReject: `${eventBaseUrl}Events/Events/GuestApproveReject`,
  SaveEventQRScan: `${eventBaseUrl}Events/Events/SaveEventQRScan?qrCode=111&UserId=111`,
  GetParticipantListDetailsByID: `${eventBaseUrl}Events/Participation/GetParticipantListDetailsByID`,
  GuestDetailsByInvitationId: `${eventBaseUrl}Events/Events/GuestDetailsByInvitationId`,
  getCompanyListForHistory: `${baseUrl}pms/Park/GetParkCompanies`,
  GetMemberdetails: `${eventBaseUrl}Events/Participation/GetMemberdetails`,
  SaveTeamDetails: `${eventBaseUrl}Events/Participation/SaveTeamDetails`,
  GetParticipantListDetailsByTenantID: `${eventBaseUrl}Events/Participation/GetParticipantListDetailsByTenantID`,
  GetEventsReport: `${eventBaseUrl}Events/Events/GetEventsReportForTA`,
  GetEventsBPReport: `${eventBaseUrl}Events/Events/GetEventsReportForBridgePlusTA`,
  eventByPark: `${eventBaseUrl}Events/Events/GetEventDetailsByParkId`,
  categoryWiseEvent: `${eventBaseUrl}Events/Events/GetEventDetailsByCategoryId`,
  GetParticipantDetailsByEventID: `${eventBaseUrl}Events/Participation/GetParticipantDetailsByEventID`,


  verifyEmailForApp: `${baseUrl}pms/Employees/VerifyEmailForApp`,
  getVehicleTypes: `${vmsBaseUrl}VMS/VMSMasterData/GetVehicleType`,
  getInvitationTypes: `${vmsBaseUrl}VMS/VMSMasterData/GetInvitationType`,
  getServicesTypes: `${vmsBaseUrl}VMS/VMSMasterData/GetServiceType`,
  getDocumentTypes: `${vmsBaseUrl}VMS/VMSMasterData/GetDocumentType`,
  getMeetingPurpose: `${vmsBaseUrl}VMS/VMSMasterData/GetMeetingPurpose`,
  GetInviteesDetails: `${vmsBaseUrl}VMS/VMSGuestInvitationEmail/GetInviteesDetailsForWeb`,
  UploadVMSDocuments: `${vmsBaseUrl}VMS/VMSGuestInvitationEmail/UploadVMSDocumentsForWeb`,
  SetGuestVehicleDetails: `${vmsBaseUrl}VMS/VMSGuestInvitationEmail/SetGuestVehicleDetailsForWeb`,
  saveParkDetails: `${baseUrl}pms/Park/SaveParkDetails`,

  // pasword expiry
  checkUserPasswordExpiry: `${pmsBaseUrl}${apiversion}UserPassword/CheckTAPasswordExpiry`,
  generateOtp: `${pmsBaseUrl}${apiversion}UserPassword/GeneratePasswordOtpForPortal`,
  verifyOtp: `${pmsBaseUrl}${apiversion}UserPassword/VerifyPasswordOtpForPortal`,
  changePassword: `${pmsBaseUrl}${apiversion}UserPassword/ChangePasswordForPortal`,
  taOtpGeneration: `${pmsBaseUrl}${apiversion}UserPassword/GenerateLoginOtpForPortal`,
  checkAuthenticatedUser: `${pmsBaseUrl}${apiversion}UserPassword/CheckUserAuthentication`,

  getTenantRfidReport: `${baseUrl}Report/TenantAccessCard`,

  //meeting rooms
  getGSTDetail: `${baseUrl}Shared/GST/GetGSTDetail`,
  GetFacilityCancellationUnit: `${baseUrl4}Facility/Facility/GetFacilityCancellationUnitsType`,
  setFacilityTypeImage: `${baseUrl4}Facility/Facility/SetFacilityTypeImage`,
  getFacilytyBookingType: `${baseUrl4}Facility/FacilityBooking/GetBookingType`,

  getCompaniesByTenantId: `${baseUrl}pms/Company/GetCompanyDetailsByTenantId`,
  saveCompany: `${baseUrl}pms/Company/updateTenantSecurity`,

  saveMeetingRoom: `${userMgmtBaseUrl}${apiversion}ParkMeetingRoom/SaveMeetingRoom`,
  updateMeetingRoomDetail: `${userMgmtBaseUrl}${apiversion}ParkMeetingRoom/SaveMeetingRoom`,
  getAllAmenities: `${userMgmtBaseUrl}${apiversion}MeetingAmenity/GetAllAmenities`,
  listAllParkMeetingRoom: `${userMgmtBaseUrl}${apiversion}ParkMeetingRoom/GetMeetingRoomByParkId`,
  detailsParkMeetingRoom: `${userMgmtBaseUrl}${apiversion}ParkMeetingRoom/GetParkMeetingDetails`,
  deleteParkMeetingRoom: `${userMgmtBaseUrl}${apiversion}ParkMeetingRoom/DeleteMeetingRoom`,
  createParkMeetingRoomCalendar: `${userMgmtBaseUrl}${apiversion}BookMeeting/AddParkMeetingRoomCalender`,
  getAllBlockDatesMeeting: `${userMgmtBaseUrl}${apiversion}BookMeeting/GetAllMeetingCalendarDetails`,
  getMeetingRoomTimeLine: `${userMgmtBaseUrl}${apiversion}BookMeeting/GetMeetingRoomTimeLineForWeb`,
  cancelBookedMeeting: `${userMgmtBaseUrl}${apiversion}BookMeeting/CancelBookingForPortal`,
  bookedMeetingRoomList: `${userMgmtBaseUrl}${apiversion}BookMeeting/GetBookedMeetingRoomList`,
  cancelBlockedMeeting: `${userMgmtBaseUrl}${apiversion}BookMeeting/CancelMeetingRoomCalendar`,
  GetMeetingRoomsReport: `${userMgmtBaseUrl}${apiversion}ParkMeetingRoom/MeetingRoomTAReport`,
  getMeetingRoomExcelReportData: `${userMgmtBaseUrl}${apiversion}ParkMeetingRoom/DownloadMeetingRoomTAReport`,

  //User consent
  getUserConsent: `${pmsBaseUrl}${apiversion}MonitorLoginActivity/GetConsentData`,
  saveUserConsent: `${pmsBaseUrl}${apiversion}MonitorLoginActivity/AddConsent`,

  regenerateTenantSecurityPassword: `${baseUrl}pms/Company/RegenerateTenantSecurityPassword`,
  approveInvitation: `${vmsBaseUrl}VMS/VMS/BulkKioskInvitationApproval`,
  getVmsKioskInvitationList: `${vmsBaseUrl}VMS/VMS/GetKioskInvitationListForLandingPage`,
  getKioskHistoryDetails: `${vmsBaseUrl}VMS/VMS/GetVMSInvitationHistoryForKiosk`,

  //pms
  getPmsInvitationList: `${baseUrl}PMS/Vehicle/GetCuroParkRequestData`,
  approveInvitationPms: `${baseUrl}PMS/Vehicle/ApproveRejectCuroParkRequest`,
  getInvitationDetailPms: `${baseUrl}PMS/Vehicle/GetCuroParkRequestDataById`,
};

export const LoaderExcludes = [
  'GetNotificationDetails',
  'ClearNotification',
  'UpdateNotification',
  'GetPortalNotificationDetails',
  'Contact',
];
